import { summarizeProductClaims } from "../../services/authClaims";
import { getCanonicalAuthUserId } from "../../services/authIdentity";

export const getShareMemberId = (currentUser, customClaims) =>
  summarizeProductClaims(customClaims)?.isMember
    ? getCanonicalAuthUserId(currentUser) || null
    : null;
